/**
 * L'accord entre les fichiers du module de la pastille (refonte modulaire
 * §8.6 ; grill Variables du 2026-09-16, D5 et D6 ; issue #88).
 *
 * Every `data-testid` more than one file reads is declared HERE, exactly as
 * `experiences/contracts.ts`, `page-editor/contracts.ts` and
 * `protocoles/contracts.ts` do for their own sub-trees, and for the same reason:
 * the pill is mounted from five zones across two sub-trees, and the suites of
 * each of them - plus `e2e/screenshots-editeur-de-page.mjs`, which does not
 * compile this package - recopy these strings. A mark renamed on one side has to
 * turn something red on the other.
 *
 * The prefix is `variable-`, a register of its own: a pill in a protocol's
 * direction and a pill in an experience's Contexte are ONE component, so its
 * marks cannot be `protocole-` on one screen and `page-` on the other.
 */
export const VARIABLE_IDS = {
  /** One per pill, in every zone; carries `data-variable` (the token without braces). */
  pill: 'variable-pastille',
  /** The fiche of D6, mounted only while open; carries `data-pinned`. */
  fiche: 'variable-fiche',
  /** The one link of the fiche: « Ouvrir la page N → », « Ouvrir le protocole ↗ ». */
  ficheOpen: 'variable-fiche-ouvrir',
  /** The `@` menu of an experience's zones, its lines, and its foot (H61). */
  menu: 'variable-menu',
  menuInsert: 'variable-menu-inserer',
  menuFooter: 'variable-menu-pied',
} as const;
